const firebaseConfig = {
    apiKey: "AIzaSyDi23M4VUbCOGZ6MgmOiiuAmSCV4uRIbt4",
    authDomain: "guru-travel.firebaseapp.com",
    databaseURL: "https://guru-travel.firebaseio.com",
    projectId: "guru-travel",
    storageBucket: "guru-travel.appspot.com",
    messagingSenderId: "1060877316362",
    appId: "1:1060877316362:web:e35833bc596ee8900b0af3",
    measurementId: "G-QQKR7V32MT"
};

export default firebaseConfig;